"use client";

import React, { useState } from "react";
import { Separator } from "@/components/ui/separator";
export default function Partners() {
  const [activeTab, setActiveTab] = useState("Brand con cui ho lavorato");
  const tabs = ["Brand con cui ho lavorato", "Brand con cui ho collaborato", "Case study", "Portfolio"];
  const brands = [{
    name: "Acquaviva SpA",
    category: "Distribuzione B2B",
    type: "Brand con cui ho lavorato"
  }, {
    name: "Acquaviva Components",
    category: "Industria",
    type: "Brand con cui ho lavorato"
  }, {
    name: "Acquaviva Analytics",
    category: "Tech",
    type: "Brand con cui ho lavorato"
  }, {
    name: "Acquaviva Vai",
    category: "Mobilità",
    type: "Brand con cui ho lavorato"
  }, {
    name: "Futura",
    category: "Settore da definire",
    type: "Brand con cui ho lavorato"
  }, {
    name: "Italserramenti Srl",
    category: "Serramenti",
    type: "Brand con cui ho lavorato"
  }, {
    name: "DKC Power Solutions",
    category: "Energia",
    type: "Brand con cui ho lavorato"
  }, {
    name: "Oh m'ideA",
    category: "Creatività",
    type: "Brand con cui ho lavorato"
  }, {
    name: "Laboratorio Cominotti",
    category: "Dental",
    type: "Brand con cui ho lavorato"
  }, {
    name: "Castello di Montaldo",
    category: "Hospitality",
    type: "Brand con cui ho lavorato"
  }, {
    name: "IKEA Brescia",
    category: "Retail",
    type: "Brand con cui ho lavorato"
  }, {
    name: "Global Tech",
    category: "Innovation",
    type: "Brand con cui ho collaborato"
  }, {
    name: "Design Core",
    category: "Studio",
    type: "Case study"
  }, {
    name: "Pixel Perfect",
    category: "Digital",
    type: "Portfolio"
  }];
  const filteredBrands = brands.filter(brand => brand.type === activeTab);
  return <section data-section-id="1670" id="partnerlogogrid" className="bg-background text-foreground py-16 md:py-32 overflow-hidden">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-3">
            <div className="lg:sticky lg:top-28">
              <div className="flex items-center gap-3">
                <span className="font-mono text-xs font-medium tracking-[0.2em] uppercase text-muted-foreground">
                  § 02 // PARTNERS
                </span>
              </div>
              <div className="mt-4 flex items-center gap-2">
                <Separator className="bg-border max-w-16" />
                <span className="block size-1 rounded-lg" style={{
                backgroundColor: "var(--primary)"
              }} aria-hidden="true" />
              </div>
              <h2 className="mt-8 text-foreground font-default" style={{
              fontWeight: 700,
              fontSize: "clamp(2rem, 4vw, 2.75rem)",
              lineHeight: 1.1,
              letterSpacing: "-0.02em"
            }}>
                Collaborating with industry leaders to build,{" "}
                <span className="italic font-serif" style={{
                color: "var(--primary)"
              }}>
                  together.
                </span>
              </h2>
              <p className="mt-6 text-muted-foreground text-sm leading-relaxed max-w-xs">
                Ogni logo - una storia. Ogni storia ha cambiato qualcosa nel percorso di crescita dei nostri partner.
              </p>
            </div>
          </div>

          {}
          <div className="lg:col-span-9">
            {}
            <div className="flex flex-wrap gap-2 mb-12 border-b border-border pb-6">
              {tabs.map((tab, i) => <button key={tab} data-index={i} onClick={() => setActiveTab(tab)} className={`px-5 py-2.5 text-xs font-mono uppercase tracking-wider transition-all rounded-lg border ${activeTab === tab ? "bg-primary text-primary-foreground border-primary" : "bg-transparent text-muted-foreground border-border hover:border-primary/50"}`}>
                  {tab}
                </button>)}
            </div>

            {}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              {filteredBrands.map((brand, i) => <div key={`${brand.name}-${i}`} data-index={i} className="group p-6 bg-card border border-border rounded-lg transition-all duration-300 hover:border-primary">
                  <h3 className="text-lg font-semibold text-foreground mb-1 group-hover:text-primary transition-colors">
                    {brand.name}
                  </h3>
                  <p className="text-xs font-mono text-muted-foreground uppercase tracking-tight">
                    {brand.category}
                  </p>
                </div>)}
              {filteredBrands.length === 0 && <div className="col-span-full py-20 text-center border border-dashed border-border rounded-lg">
                  <p className="text-muted-foreground font-mono text-sm">Nessun elemento trovato in questa categoria.</p>
                </div>}
            </div>

            {}
            <div className="mt-16 flex flex-col md:flex-row md:items-center justify-between gap-6 pt-8 border-t border-border">
              <div className="flex items-center gap-3">
                <span className="block size-1 rounded-lg" style={{
                backgroundColor: "var(--primary)"
              }} aria-hidden="true" />
                <span className="font-mono text-[0.6875rem] tracking-[0.12em] uppercase text-muted-foreground">
                  {brands.length} strategic partners — driving innovation
                </span>
              </div>
              <div className="flex gap-4">
                <div className="h-1 w-12 bg-primary rounded-lg" />
                <div className="h-1 w-8 bg-border rounded-lg" />
                <div className="h-1 w-4 bg-border rounded-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}